<template>
  <div class="card_container_static">
    <div class="square_card" :id="squareId">
      <div class="front gridsquare lighten-4 squared flow-text">
        <svg width="100%" height="100%">
          <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle">{{ name }}</text>
        </svg>
      </div>
      <div class="gridsquare squared back">
        <svg width="100%" height="100%">
          <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle">{{ name }}</text>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    row: Number,
    col: Number
  },
  data () {
    return {
      squareId: 'gridsquare_r' + this.row + 'c' + this.col
    }
  }
}
</script>
